import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

export const FieldContainer = styled.div`
  &&& {
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    flex-wrap: wrap;
    gap: 0 ${pxToRem(10)};
    .ui.dropdown {
      margin-bottom: 0;
    }
    .cssCriteriaPropertyGroupFieldDropdown {
      width: 26%;
    }
    .cssCriteriaPropertyGroupFieldViewModeValue {
      font-weight: 600; /** css file conversion */
      align-items: center;
      display: flex;
      justify-content: center;
      min-height: ${pxToRem(20)}; /** css file conversion */
      &:empty {
        margin: 0;
      }
    }
    .cssCriteriaPropertyGroupValueTypeDropdown {
      height: ${pxToRem(38)}; /** css file conversion */
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      &.ui.input {
        flex: 1 1 auto;
      }
      &.ui.dropdown {
        &:hover {
          z-index: 1;
        }
      }
    }
    @media (max-width: 1230px) {
      gap: 0 0;
    }
  }
`;

export const MainContainer = styled.div<{ isViewMode: boolean; isGeoLocationField: boolean }>`
  display: flex;
  margin-bottom: ${({ isViewMode }) => (isViewMode ? 0 : pxToRem(20))}; /** css file conversion */
  margin-top: ${({ isViewMode }) =>
    isViewMode ? pxToRem(10) : 'inherit'}; /** css file conversion */
  height: 100%;
  width: 100%;
  transition: height 0s, width 0s, opacity 0s;
  ${FieldContainer} {
    flex-wrap: wrap;
  }
  .cssCriteriaPropertyGroupActionButtons {
    opacity: 0;
    transition: opacity 0.2s;
    height: ${pxToRem(38)}; /** css file conversion */
    > .cssCriteriaPropertyGroupActionActionButton {
      margin-left: -${pxToRem(1)}; /** css file conversion */
      margin-right: 0;

      &:first-child {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
      &:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }
  &:hover,
  &:focus {
    .cssCriteriaPropertyGroupActionButtons {
      opacity: 1;
    }
  }
  @media (max-width: 1230px) {
    .ui.dropdown {
      border-radius: 0;
    }
    > * {
      .ui.dropdown {
        border-radius: 0;
        margin-bottom: -1px !important;
        margin-right: 0 !important;
        flex: 1 1 auto;
      }
      margin-bottom: -1px !important;
    }
    .cssCriteriaPropertyGroupFieldDropdown {
      margin-right: -1px !important;
      min-width: 60%;
    }
  }
`;

export const Label = styled.div<{ isViewMode: boolean }>`
  align-items: center;
  background: none;
  display: flex;
  font-size: 0.85714286rem; /** css file conversion */
  color: rgba(0, 0, 0, 0.6); /** css file conversion */
  justify-content: flex-end;
  margin: ${({ isViewMode }) => (isViewMode ? `0 ${pxToRem(10)} 0 0` : `0 ${pxToRem(10)} 0 0`)};
  width: ${pxToRem(42)};
  min-width: ${pxToRem(42)};
  height: ${pxToRem(39)};
  text-transform: lowercase;
`;
